// eslint-disable-next-line
// @ts-ignore
import FaceDetectionWebWorker from 'comlink-loader!./faceDetectionWebWorker';
import FaceDetectionFakeWorker from './faceDetectionFakeWorker';

export default class FaceDetectionWorkerFactory {
  public static createWebWorker() {
    return new FaceDetectionWebWorker();
  }

  public static createFakeWorker() {
    return new FaceDetectionFakeWorker();
  }
}
